__turbopack_context__.v({
  "main": "venuesMap-module-scss-module__zrIG-G__main",
  "marker": "venuesMap-module-scss-module__zrIG-G__marker",
  "tooltip": "venuesMap-module-scss-module__zrIG-G__tooltip",
  "tooltip_name": "venuesMap-module-scss-module__zrIG-G__tooltip_name",
  "wrapper": "venuesMap-module-scss-module__zrIG-G__wrapper",
});
